import React, { type PropsWithChildren, useCallback, useState } from 'react'
import { Button, CloseButton, Drawer, Portal } from '@chakra-ui/react'
import { useNavigate } from '@tanstack/react-router'

import { useEndCurrentShift } from '../api/mutations/use-end-current-shift'

type ShiftEndDrawerProps = PropsWithChildren<{
    shiftId: number
}>

export const ShiftEndDrawer: React.FC<ShiftEndDrawerProps> = ({ children, shiftId }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { endCurrentShift, isPending } = useEndCurrentShift(shiftId)
    const navigate = useNavigate()

    const handleEndShift = useCallback(async () => {
        await endCurrentShift()
        navigate({ to: '/shifts' })
    }, [endCurrentShift, navigate])

    return (
        <Drawer.Root
            open={isOpen}
            placement={'bottom'}
            onOpenChange={(event) => setIsOpen(event.open)}
        >
            <Drawer.Trigger asChild>{children}</Drawer.Trigger>
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner>
                    <Drawer.Content roundedTop='2xl'>
                        <Drawer.Header>
                            <Drawer.Title>Завершить смену</Drawer.Title>
                        </Drawer.Header>
                        <Drawer.Body pt='0'>
                            <p>Вы уверены, что хотите завершить смену?</p>
                        </Drawer.Body>
                        <Drawer.Footer>
                            <Drawer.ActionTrigger asChild>
                                <Button
                                    borderRadius='full'
                                    colorPalette='gray'
                                    flex='1'
                                    size='lg'
                                    variant='subtle'
                                >
                                    Закрыть
                                </Button>
                            </Drawer.ActionTrigger>
                            <Button
                                borderRadius='full'
                                colorPalette='red'
                                disabled={isPending}
                                flex='1'
                                loading={isPending}
                                size='lg'
                                variant='subtle'
                                onClick={handleEndShift}
                            >
                                Завершить
                            </Button>
                        </Drawer.Footer>
                        <Drawer.CloseTrigger asChild>
                            <CloseButton size='sm' />
                        </Drawer.CloseTrigger>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    )
}
